/******** cart.js ********/

/******* AddToCart *******/
class AddToCart implements AddToCartInterface {
  OCForm1: HTMLFormElement;
  promoProps: PromoProps;
  elementIDs: ElementIDs;
  itemProps: ItemProps;
  invtProps: InvtProps;

  constructor({
    promoProps,
    elementIDs,
    itemProps,
    invtProps,
  }) {
    this.OCForm1 = document.querySelector('#OCForm1');
    const defaultElementIds = {
      addToCartBtn: '#addToCartBtn',
      subscribeBtn: '#subscribeBtn',
      productSubAddToCartBtn: '#productSubAddToCartBtn',
      productSubSubscribeBtn: '#productSubSubscribeBtn',
      addToBagBtn: '#addToBagBtn',
      addOnProductID: 'addOnProductID'
    };
    this.promoProps = promoProps || {};
    this.elementIDs = {
      ...defaultElementIds,
      ...elementIDs
    };
    this.itemProps = itemProps || {};
    this.invtProps = invtProps || {};
  }
  getPromoValue(name: string): void {
    return this.promoProps[name];
  }
  setPromoValue(name: string, value: string): void {
    this.promoProps[name] = value;
  }
  ajaxAddToCart(productIndex: number): void {
    showHideLoader('show', productIndex);
    const justAddedArray = [];
    const productIDFields = this.OCForm1.elements['productID'];
    const mainExtensionIndices = [];
    const ajaxObj = new XMLHttpRequest();
    let errorCount = 0;
    let justAddedItemID = '';
    let justAddedInvtID = '';
    let justAddedExtensionCode = '';
    let justAddedExtension = '';
    let justAddedExtensionGroup = '';
    let justAddedQuantity = 0;
    let ajaxParamItemID = '';
    let ajaxParamQuantity = '';
    let ajaxParamProductIDExtensionGroups = '';
    let ajaxParamExtensions = '';
    if (productIDFields.length !== undefined) {
      if (productIDFields.length > 2 && productIndex === 1 && productIDFields[(productIndex + 1)].checked) {
        justAddedItemID = productIDFields[2].value;
        justAddedQuantity = this.OCForm1.elements["quantity"][2].value;
        ajaxParamProductIDExtensionGroups = this.OCForm1.elements["productIDExtensionGroups"][2].value;
      } else {
        justAddedItemID = productIDFields[productIndex].value;
        justAddedQuantity = this.OCForm1.elements["quantity"][productIndex].value;
        ajaxParamProductIDExtensionGroups = this.OCForm1.elements["productIDExtensionGroups"][productIndex].value;
      }
    } else {
      justAddedItemID = productIDFields.value;
      justAddedQuantity = this.OCForm1.elements["quantity"].value;
      ajaxParamProductIDExtensionGroups = this.OCForm1.elements["productIDExtensionGroups"].value;
    }
    if (justAddedQuantity === 0 || justAddedQuantity > 99 || !Number.isInteger(parseFloat(justAddedQuantity.toString())) || isNaN(Number(justAddedQuantity))) {
      errorCount++;
    }
    justAddedInvtID = HAH.product.getProductID(justAddedItemID, productIndex);
    if (justAddedInvtID.indexOf('SELECT') > -1) {
      errorCount++;
    } else {
      const stkItem = this.invtProps[justAddedInvtID].stkItem||0;
      const invtIDQtyAvail = this.invtProps[justAddedInvtID].qtyAvail||0;
      if (stkItem != 0 && invtIDQtyAvail <= 0){
        errorCount++;
        alert('Sold out! Please select another option.')
      }
    }
    if (errorCount === 0) {
      let mainExtensionGroupArray = ajaxParamProductIDExtensionGroups.split(';');
      let extensionValue = '';
      for (let i = 0; i < mainExtensionGroupArray.length; i++) {
        if (mainExtensionGroupArray[i] !== '') {
          let domParentSelect: any = document.getElementById(`${justAddedItemID}${mainExtensionGroupArray[i]}`);
          let selectIndex = domParentSelect.selectedIndex;
          extensionValue = domParentSelect.options[selectIndex].value;
          if (extensionValue !== '') {
            mainExtensionIndices.push(selectIndex);
            ajaxParamExtensions += `&${justAddedItemID}${mainExtensionGroupArray[i]}=${extensionValue}`;
            justAddedExtensionGroup += `${domParentSelect.options[0].text};`;
            justAddedExtension += `${domParentSelect.options[selectIndex].text};`;
            justAddedExtensionCode += (<HTMLSelectElement>document.getElementById(justAddedItemID + mainExtensionGroupArray[i])).options[(<HTMLSelectElement>document.getElementById(justAddedItemID + mainExtensionGroupArray[i])).options.selectedIndex].value;
          }
        }
      }
      justAddedArray.push({
        itemID: justAddedItemID,
        invtID: justAddedInvtID,
        descr: this.itemProps[justAddedItemID].Name,
        image: this.itemProps[justAddedItemID].Thumb,
        extensionGroup: justAddedExtensionGroup,
        extension: justAddedExtension,
        price: this.itemProps[justAddedItemID].Price,
        listprice: this.itemProps[justAddedItemID].ListPrice,
        qty: justAddedQuantity
      });
      ajaxParamItemID = justAddedItemID;
      ajaxParamQuantity = justAddedQuantity.toString();
      if (this.promoProps.promoType !== undefined && this.promoProps.promoType.toUpperCase() === 'BOGO') {
        for (let j = 0; j < this.promoProps.bogoPairs.length; j++) {
          if (justAddedItemID.toLowerCase().indexOf(this.promoProps.bogoPairs[j].mainSku.toLowerCase()) !== -1 || (this.promoProps.bogoPairs[j].subSku !== '' && justAddedItemID.toLowerCase().indexOf(this.promoProps.bogoPairs[j].subSku.toLowerCase()) !== -1)) {
            justAddedArray.push({
              itemID: this.promoProps.bogoPairs[j].gwpSku,
              invtID: this.promoProps.bogoPairs[j].gwpSku,
              descr: `${this.itemProps[justAddedItemID].Name.replace(' - Subscription', '')} - ${this.promoProps.freeGiftRemarkCopy}`,
              image: this.itemProps[justAddedItemID].Thumb,
              extensionGroup: justAddedExtensionGroup,
              extension: justAddedExtension,
              price: '0',
              listprice: this.itemProps[justAddedItemID].ListPrice,
              qty: justAddedQuantity
            });
            ajaxParamItemID += `,${this.promoProps.bogoPairs[j].gwpSku}`;
            ajaxParamQuantity += `,${justAddedQuantity}`;
          }
        }
      }
      if (productIDFields[productIndex + 1] !== undefined) {
        if (productIDFields[productIndex + 1].checked && this.OCForm1.checkValidity()) {
          const mainItemID = productIDFields[productIndex].value;
          justAddedItemID = productIDFields[productIndex + 1].value;
          justAddedInvtID = justAddedItemID;
          ajaxParamItemID += `,${justAddedItemID}`;
          ajaxParamQuantity += `,${justAddedQuantity}`;
          ajaxParamProductIDExtensionGroups += `,${this.OCForm1.elements["productIDExtensionGroups"][productIndex + 1].value}`;
          mainExtensionGroupArray = this.OCForm1.elements["productIDExtensionGroups"][productIndex + 1].value.split(';');
          for (let i = 0; i < mainExtensionGroupArray.length; i++) {
            if (mainExtensionGroupArray[i] !== '') {
              const addOnExtensionGroupArray = this.OCForm1.elements["productIDExtensionGroups"][productIndex].value.split(';');
              let extensionGroupIndex = -1;
              for (let p = 0; p < addOnExtensionGroupArray.length; p++) {
                if (mainExtensionGroupArray[i] === addOnExtensionGroupArray[p]) {
                  extensionGroupIndex = p;
                  p = addOnExtensionGroupArray.length;
                }
              }
              if (extensionGroupIndex > -1) {
                (<HTMLSelectElement>document.getElementById(`${productIDFields[productIndex + 1].value}${mainExtensionGroupArray[i]}`)).options.selectedIndex = mainExtensionIndices[extensionGroupIndex];
              } else {
                (<HTMLSelectElement>document.getElementById(`${productIDFields[productIndex + 1].value}${mainExtensionGroupArray[i]}`)).options.selectedIndex = mainExtensionIndices[i];
              }
              const itemsObj = this.itemProps[productIDFields[productIndex].value];
              if (itemsObj.addOn.hasOwnProperty('Override')) {
                if (justAddedExtensionCode !== '') {
                  for (let k = 0; k < itemsObj.addOn.Override.length; k++) {
                    if (justAddedExtensionCode.indexOf(itemsObj.addOn.Override[k].mainExt) !== -1) {
                      extensionValue = itemsObj.addOn.Override[k].addOnExt;
                      justAddedExtension = itemsObj.addOn.Override[k].addOnExtTxt;
                    }
                  }
                } else {
                  extensionValue = itemsObj.addOn.Override[0].addOnExt;
                  justAddedExtension = itemsObj.addOn.Override[0].addOnExtTxt;
                }
              } else {
                extensionValue = (<HTMLSelectElement>document.getElementById(`${productIDFields[productIndex + 1].value}${mainExtensionGroupArray[i]}`)).options[(<HTMLSelectElement>document.getElementById(`${productIDFields[productIndex + 1].value}${mainExtensionGroupArray[i]}`)).options.selectedIndex].value;
                justAddedExtension = (<HTMLSelectElement>document.getElementById(`${productIDFields[productIndex + 1].value}${mainExtensionGroupArray[i]}`)).options[(<HTMLSelectElement>document.getElementById(`${productIDFields[productIndex + 1].value}${mainExtensionGroupArray[i]}`)).options.selectedIndex].text;
              }
              if (extensionValue !== '') {
                justAddedInvtID += extensionValue;
                ajaxParamExtensions += `&${productIDFields[productIndex + 1].value}${mainExtensionGroupArray[i]}=${extensionValue}`;
                justAddedExtensionGroup = (<HTMLSelectElement>document.getElementById(`${justAddedItemID}${mainExtensionGroupArray[i]}`)).options[0].text;
              }
            }
          }
          if (justAddedInvtID !== '') {
            justAddedArray.push({
              itemID: justAddedItemID,
              invtID: justAddedInvtID,
              descr: this.itemProps[mainItemID].addOn.Name,
              image: this.itemProps[mainItemID].addOn.Thumb,
              extensionGroup: justAddedExtensionGroup,
              extension: justAddedExtension,
              listprice: this.itemProps[mainItemID].addOn.ListPrice,
              price: this.itemProps[mainItemID].addOn.Price,
              qty: justAddedQuantity
            });
          }
        }
      }
      if (errorCount === 0) {
        let ajaxParams = `&posting=TRUE&actionType=CARTADD&productID=${encodeURIComponent(ajaxParamItemID)}&quantity=${encodeURIComponent(ajaxParamQuantity)}&productIDExtensionGroups=${encodeURIComponent(ajaxParamProductIDExtensionGroups)}${ajaxParamExtensions}`;
        let ajaxURL = 'ajax/cart.aspx';
        let ajaxResults = '';
        ajaxObj.open('POST', ajaxURL, true);
        ajaxObj.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;');
        ajaxObj.send(ajaxParams);
        ajaxObj.onreadystatechange = function () {
          if (ajaxObj.readyState === 4) {
            ajaxResults = ajaxObj.responseText + '';
            if (ajaxResults !== '') {
              const tmpErrorMessage = /<errormessage>.+<\/errormessage>/i.exec(ajaxResults);
              if (tmpErrorMessage) {
                showHideLoader('hide', productIndex);
              } else {
                quickCartObj.updateQuickCart(justAddedArray, ajaxResults, productIndex);
                justAddedArray.length = 0;
              }
            }
          }
        };
      }
    } else {
      showHideLoader('hide', productIndex);
    }
  }

  addToBag(productIndex: number): void {
    showHideLoader('show', productIndex);
    const justAddedArray = [];
    const productIDFields = this.OCForm1.elements['productID'];
    const mainExtensionIndices = [];
    const ajaxObj = new XMLHttpRequest();
    let errorCount = 0;
    let justAddedItemID = '';
    let justAddedInvtID = '';
    let justAddedExtensionCode = '';
    let justAddedExtension = '';
    let justAddedExtensionGroup = '';
    let justAddedQuantity = 0;
    let ajaxParamItemID = '';
    let ajaxParamQuantity = '';
    let ajaxParamProductIDExtensionGroups = '';
    let ajaxParamExtensions = '';
    if (productIDFields.length !== undefined) {
      if (productIDFields.length > 2 && productIndex === 1 && productIDFields[(productIndex + 1)].checked) {
        justAddedItemID = productIDFields[2].value;
        justAddedQuantity = this.OCForm1.elements["quantity"][2].value;
        ajaxParamProductIDExtensionGroups = this.OCForm1.elements["productIDExtensionGroups"][2].value;
      } else {
        justAddedItemID = productIDFields[productIndex].value;
        justAddedQuantity = this.OCForm1.elements["quantity"][productIndex].value;
        ajaxParamProductIDExtensionGroups = this.OCForm1.elements["productIDExtensionGroups"][productIndex].value;
      }
    } else {
      justAddedItemID = productIDFields.value;
      justAddedQuantity = this.OCForm1.elements["quantity"].value;
      ajaxParamProductIDExtensionGroups = this.OCForm1.elements["productIDExtensionGroups"].value;
    }
    if (justAddedQuantity === 0 || isNaN(Number(justAddedQuantity))) {
      errorCount++;
    }
    justAddedInvtID = $('ul.scent-options li.active').data('invtid');
    if (justAddedInvtID == null) {
      alert('Please select an option.');
      location.reload();
      errorCount++;
    }
    if (errorCount === 0) {
      let mainExtensionGroupArray = ajaxParamProductIDExtensionGroups.split(';');
      let extensionValue = justAddedInvtID.replace(justAddedItemID, "");
      justAddedArray.push({
        itemID: justAddedItemID,
        invtID: justAddedInvtID,
        descr: this.itemProps[justAddedItemID].Name,
        image: this.itemProps[justAddedItemID].Thumb,
        extensionGroup: $('ul.scent-options li.active').data('groupname') + ";",
        extension: $('ul.scent-options li.active').data('descr'),
        price: this.itemProps[justAddedItemID].Price,
        listprice: this.itemProps[justAddedItemID].ListPrice,
        qty: justAddedQuantity
      });
      ajaxParamItemID = justAddedItemID;
      ajaxParamQuantity = justAddedQuantity.toString();
      if (this.promoProps.promoType !== undefined && this.promoProps.promoType.toUpperCase() === 'BOGO') {
        for (let j = 0; j < this.promoProps.bogoPairs.length; j++) {
          if (justAddedItemID.toLowerCase().indexOf(this.promoProps.bogoPairs[j].mainSku.toLowerCase()) !== -1 || (this.promoProps.bogoPairs[j].subSku !== '' && justAddedItemID.toLowerCase().indexOf(this.promoProps.bogoPairs[j].subSku.toLowerCase()) !== -1)) {
            justAddedArray.push({
              itemID: this.promoProps.bogoPairs[j].gwpSku,
              invtID: this.promoProps.bogoPairs[j].gwpSku,
              descr: `${this.itemProps[justAddedItemID].Name.replace(' - Subscription', '')} - ${this.promoProps.freeGiftRemarkCopy}`,
              image: this.itemProps[justAddedItemID].Thumb,
              extensionGroup: justAddedExtensionGroup,
              extension: justAddedExtension,
              price: '0',
              listprice: this.itemProps[justAddedItemID].ListPrice,
              qty: justAddedQuantity
            });
            ajaxParamItemID += `,${this.promoProps.bogoPairs[j].gwpSku}`;
            ajaxParamQuantity += `,${justAddedQuantity}`;
          }
        }
      }
      ajaxParamExtensions += `&${justAddedItemID}${mainExtensionGroupArray[0]}=${extensionValue}`;
      if (errorCount === 0) {
        let ajaxParams = `&posting=TRUE&actionType=CARTADD&productID=${encodeURIComponent(ajaxParamItemID)}&quantity=${encodeURIComponent(ajaxParamQuantity)}&productIDExtensionGroups=${encodeURIComponent(ajaxParamProductIDExtensionGroups)}${ajaxParamExtensions}`;
        let ajaxURL = 'ajax/cart.aspx';
        let ajaxResults = '';
        ajaxObj.open('POST', ajaxURL, true);
        ajaxObj.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;');
        ajaxObj.send(ajaxParams);
        ajaxObj.onreadystatechange = function () {
          if (ajaxObj.readyState === 4) {
            ajaxResults = ajaxObj.responseText + '';
            if (ajaxResults !== '') {
              const tmpErrorMessage = /<errormessage>.+<\/errormessage>/i.exec(ajaxResults);
              if (tmpErrorMessage) {
                showHideLoader('hide', productIndex);
              } else {
                quickCartObj.updateQuickCart(justAddedArray, ajaxResults, productIndex);
                justAddedArray.length = 0;
              }
            }
          }
        };
      } else {
        showHideLoader('hide', productIndex);
      }
    }
  }
  bindElementHandlers(): void {
    const addToCartBtn = $(this.elementIDs.addToCartBtn);
    const addToBagBtn = $(this.elementIDs.addToBagBtn);
    const subscribeBtn = $(this.elementIDs.subscribeBtn);
    const productSubAddToCartBtn = $(this.elementIDs.productSubAddToCartBtn);
    const productSubSubscribeBtn = $(this.elementIDs.productSubSubscribeBtn);
    const subsItemIndex = (this.OCForm1[this.elementIDs.addOnProductID] === undefined) ? 1 : 2;
    const collectionPItemCount = this.elementIDs.collectionPItemCount;
    if (collectionPItemCount !== undefined && collectionPItemCount > 0) {
      for (let i = 0; i < collectionPItemCount; i++) {
        let collectionAddToCartBtn = $(this.elementIDs.collectionAddToCartBtnPrefix + i);
        if (collectionAddToCartBtn.length) {
          collectionAddToCartBtn.on('click', () => {
            this.ajaxAddToCart(i);
          });
        }
      }
    }
    if (addToCartBtn.length) {
      addToCartBtn.on('click', () => {
        this.ajaxAddToCart(0);
      });
    }
    if (addToBagBtn.length) {
      addToBagBtn.on('click', () => {
        this.addToBag(0);
      });
    }
    if (subscribeBtn.length) {
      subscribeBtn.on('click', () => {
        this.ajaxAddToCart(subsItemIndex);
      });
    }
    if (productSubAddToCartBtn.length) {
      productSubAddToCartBtn.on('click', () => {
        this.ajaxAddToCart(0);
      });
    }
    if (productSubSubscribeBtn.length) {
      productSubSubscribeBtn.on('click', () => {
        this.ajaxAddToCart(subsItemIndex);
      });
    }
    const quantity = this.OCForm1.elements["quantity"];
    if (quantity.length !== undefined) {
      for (let i = 0; i < quantity.length; i++) {
        quantity[i].addEventListener('change', () => {
          if (isNaN(parseInt(quantity[i].value)) || parseInt(quantity[i].value) <= 0) {
            quantity[i].value = 1;
          }
        });
      }
    } else {
      quantity.addEventListener('change', () => {
        if (isNaN(parseInt(quantity.value)) || parseInt(quantity.value) <= 0) {
          quantity.value = 1;
        }
      });
    }
  }
}
const addToCartObj = new AddToCart(classOptions);



/******* Interfaces *******/
interface AddToCartInterface {
  promoProps: PromoProps;
  elementIDs: ElementIDs;
  itemProps: ItemProps;
  invtProps: InvtProps;
}

interface ElementIDs {
  addOnProductID: string;
  addToCartBtn: string;
  addToBagBtn: string;
  productSubAddToCartBtn: string;
  productSubSubscribeBtn: string;
  subscribeBtn: string;
  collectionPItemCount?: number;
  collectionAddToCartBtnPrefix?: string;
}